export default __webpack_public_path__ + "static/media/daniela_xl.da7e482c.jpg";